export default __webpack_public_path__ + "static/article-taking-out-a-used-car-loan-v2-0255f61133d7e72cd59b4a7550df0f10.jpg";